const invitation = {
    find_your_tenants: 'Tìm tenant của bạn',
    find_tenants_description: 'Địa chỉ email của bạn có thể đã được đăng ký với nhiều tenant. Bạn có thể chọn tham gia các tenant hiện có hoặc tiếp tục tạo một tenant mới.',
    create_new_tenant: 'Tạo tenant mới',
    email_not_match_title: 'Bạn đang đăng nhập với\n{{email}}',
    email_not_match_description: 'Vui lòng đăng nhập bằng tài khoản chính xác để chấp nhận lời mời và trở thành thành viên của tổ chức.',
    switch_account: 'Đăng nhập bằng tài khoản khác',
    invalid_invitation_status: 'Lời mời không hợp lệ. Vui lòng liên hệ quản trị viên và thử lại.',
    invitation_not_found: 'Không tìm thấy lời mời. Vui lòng liên hệ quản trị viên.',
};
export default Object.freeze(invitation);
